import React, { useEffect } from "react";
import { Button, Dropdown, Menu, Input, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleRoModel } from "../saleRoModel";
import useNavModel from "@/model/navModel";
import { useSaleRoDetailModel } from "./details/saleRoDetailModel"
import { globalPrompt } from "@/components/message";
import { DownOutlined } from "@ant-design/icons";
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
export const DataBox = () => {
    const { descTotal, selectedRowKeys, selectedRow, rowsDescTotal, setSettleScaniaPrint, setSelectedRowKeys, invalidate, detailsExport, exportSaleRo, setPrint } = useSaleRoModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const { resetEditCatch } = useSaleRoDetailModel()
    const { shopAndOrg: { shopCode } } = useGlobalModel()
    const desc: IDescription[] = [
        {
            label: "退货总量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,// "1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "退货总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),// "1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "已付总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.receivableAmount : rowsDescTotal.receivableAmount),// "1232",
            color: DescriptionColorEnum.red
        },
        {
            label: "退货成本",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.latestPurPrice : rowsDescTotal.latestPurPrice),// "1232",
            color: DescriptionColorEnum.red
        }
    ]
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status === "sale-return-status.settle") {
            globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
            return;
        }
        if (selectedRow.status === "sale-return-status.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            return;
        }
        let saleSoEditKey = "5-3-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow?.returnCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "销售退货单跳转详情",
                type: "warning",
                text: "您还有销售退货单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow?.returnCode as string, mode: "edit" });
                    resetEditCatch()
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "5-3-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow?.returnCode as string, mode: "look", },
            true
        );
    }

    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrint(true)
    }
    const exportMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => exportSaleRo()}>列表导出</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => detailsExport()}>详情导出</span>
                </Menu.Item>
            </Menu>
        )
    }
    const onSettleSknyPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setSettleScaniaPrint(true)
    }
    const cancellation = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let cancelReason: string = ""
        globalPrompt("modal", {
            title: "销售退货单作废",
            type: "error",
            text: <><span>请输入作废原因</span>
                <Input onChange={(e) => { cancelReason = e.target.value }} /></>,
            okText: "确定",
            onOk: () => {
                invalidate(cancelReason)
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_R_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("5-3-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_R_ED}>

            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_R_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_R_PRINT}>
            {shopCode === "SHOP-M-00000020" ||
                shopCode === "SHOP-M-00000019" ||
                shopCode === "SHOP-M-00000021" ?
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onSettleSknyPrint}
                >结算打印</Button> :
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onPrint}
                >打印</Button>
            }
        </YhAuth>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onPrint}
        >打印</Button>
        <YhAuth resCode={ResourceAuthEnum.S_R_CANCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={cancellation}
            >作废</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.S_R_EX}>
            <Dropdown overlay={exportMenu}>
                {/* <Tooltip placement="topLeft" title={disableExportMsg}> */}
                <Button
                    // disabled={true}
                    className="mr-5"
                    type="primary"
                    shape="round"
                >导出<DownOutlined /></Button>
                {/* </Tooltip> */}
            </Dropdown>
        </YhAuth>
        {/* <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => exportSaleRo().then()}
        >导出</Button> */}
    </>;

    return (
        // <YhBox title="销售退货列表" descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}>
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}